import config from "@/config";
var signalR = window.signalR;
import Cookies from "js-cookie";
import {
    TOKEN_KEY
} from "@/libs/util";
import {
    Notification
} from "element-ui";

import appState from "./app";

export default {
    state: {
        osrCon: '',
        team: {
            notSeenConversationCount: 0
        }
    },
    mutations: {
        setNotSeenCount(state, count) {
            state.team.notSeenConversationCount = count;
        },
        setOsrCon(state, osrCon) {
            //console.log(id);
            state.osrCon = osrCon;
        },
    },
    actions: {
        handleSignalR({
            commit,
            state
        }) {
            //console.log('state=> ', appState);
            let _hubBaseUrl='https://mobcoreapi.gosmart.mn/';
            if(appState.state.activeGroup.hubBaseUrl!=undefined && appState.state.activeGroup.hubBaseUrl!=''){
                _hubBaseUrl= appState.state.activeGroup.hubBaseUrl;
            }
            //console.log('_hubBaseUrl', _hubBaseUrl);


            return new Promise(resolve => {
                let osrCon = new signalR.HubConnectionBuilder()
                    .withUrl(_hubBaseUrl + "mainHub", {
                        accessTokenFactory: () => Cookies.get(TOKEN_KEY)
                    })
                    .configureLogging(signalR.LogLevel.Information)
                    .build();

                osrCon
                    .start()
                    .then(function () {
                        //TODO: Golomt-nh gargahgui baiy geher n commentolchihloo. hervee gargaval golomt != gej gargah bairlaliin huvid bottom left yumu right bvl zugeer bh
                        // Notification.info({
                        //     message: "Амжилттай холбогдлоо.",
                        //     duration: 5000,
                        //     type: "info",
                        //     position: 'top-right',
                        //     offset: 50
                        // });
                        commit("setOsrCon", osrCon);

                        osrCon.on(
                            "v2recieveTeamMessage",
                            () => {
                                commit("setNotSeenCount", state.team.notSeenConversationCount + 1);
                            }
                        );

                        osrCon.on(
                            "receiveGLobalNotification",
                            (e) => {
                                if(e.notification.type==3){                                    
                                    window.location.href = e.notification.link;
                                    //Notification.show
                                    Notification.info({
                                        message: e.notification.msg,
                                        duration: e.notification.timeout*1000,
                                        type: "info",
                                        position: "top-right",
                                        offset: 50
                                      });
                                }
                                //commit("setNotSeenCount", state.team.notSeenConversationCount + 1);
                            }
                        );

                        resolve(true);
                    })
                    .catch(() => {
                        resolve(false);
                    });
            });
        },
        handleTeamNotSeenCount({
            commit
        }, count) {
            return new Promise((resolve, reject) => {
                try {
                    commit("setNotSeenCount", count);
                    resolve(count)
                } catch (error) {
                    reject(error)
                }
            });
        },
    }
}